import { z } from 'zod';

export const realtimeMarriageVerificationSchema = z.object({
    idNumber: z.string({ error: 'ID Number is required' })
        .regex(/^\d+$/, "ID Number must be numeric"),
    firstName: z.string().optional().or(z.literal('')),
    surname: z.string().optional().or(z.literal('')),
    yourReference: z.string().optional().or(z.literal('')),
    voucherCode: z.string().optional().or(z.literal('')),
});

export type RealtimeMarriageVerificationPayload = z.infer<typeof realtimeMarriageVerificationSchema>;

export const realtimeMarriageVerificationService = {
    createPayload: (formData: z.infer<typeof realtimeMarriageVerificationSchema>): RealtimeMarriageVerificationPayload => {
        return {
            ...formData
        };
    },

    executeReport: async (payload: RealtimeMarriageVerificationPayload): Promise<any> => {
        const axios = (await import('../axiosConfig')).default;
        const response = await axios.post('/verification/realtime-marriage-verification', payload);
        return response.data;
    }
};
